import {
	buildSearchOptionClauses,
	type SearchOperator,
} from '../helpers/statelessFiltersFromSessionStorage';
import { SelectedSearchOption } from '../helpers/types';

interface BuildQueryWithSearchOptions {
	selectedSearchOptions: SelectedSearchOption[];
	searchTerm: string;
	searchOperator: SearchOperator;
}

// Builds the query clause for searches in Spotlight (`spotlightAPI.searchSpotlightAssets`).
//   - No options → raw term. Unlike the applied terms (`searchTerms`), which
//     are wrapped as `(term)` because several of them are joined with AND,
//     the dropdown sends a single term.
//   - Empty term → '' so callers skip the API call.
//   - Otherwise: the selected options' clauses (`buildSearchOptionClauses`,
//     shared with the applied terms), joined with AND; without a known option
//     the term is used as-is.
export function buildQueryWithSearchOptions({
	selectedSearchOptions,
	searchTerm,
	searchOperator,
}: BuildQueryWithSearchOptions) {
	if (selectedSearchOptions.length === 0) {
		return searchTerm;
	}

	if (!searchTerm.trim()) {
		return '';
	}

	const chipClauses = buildSearchOptionClauses(searchTerm, selectedSearchOptions, searchOperator);

	const termClauses = chipClauses.length > 0 ? chipClauses : [searchTerm];

	return termClauses.join(' AND ');
}
